import { render } from "./gsrsu04020304.vue?vue&type=template&id=52223511&scoped=true"
import script from "./gsrsu04020304.vue?vue&type=script&lang=js"
export * from "./gsrsu04020304.vue?vue&type=script&lang=js"

import "./gsrsu04020304.vue?vue&type=style&index=0&id=52223511&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52223511"]])

export default __exports__